/** Helpers shared by the AI topic-quiz item renderers. */
import React from "react";
import { MixedText } from "../../grammar/shared";

const AR_RE = /[؀-ۿ]/;
const LATIN_RE = /[A-Za-z]/;

/** An Arabic-only string lays out RTL; mixed strings stay LTR via MixedText. */
export const isArabicOnly = (s) => AR_RE.test(s || "") && !LATIN_RE.test(s || "");

export function ChoiceLabel({ text }) {
  return isArabicOnly(text) ? <>{text}</> : <MixedText text={text} />;
}

/** The English task line above every item. */
export function Prompt({ children }) {
  return (
    <p className="text-base text-center font-medium mb-5" style={{ color: "var(--parchment)" }}>
      <MixedText text={children} />
    </p>
  );
}

/** A large centred Arabic line (word, sentence or dialogue line). */
export function ArabicLine({ text, size = "text-4xl", color = "var(--parchment)", children }) {
  return (
    <p dir="rtl" lang="ar" className={`font-arabic ${size} leading-[2.1] text-center mt-4 mb-4`} style={{ color }}>
      {children || text}
    </p>
  );
}

/** Gold primary action, used for Check / Next. */
export function PrimaryButton({ children, ...props }) {
  return (
    <button
      type="button"
      {...props}
      className="inline-flex items-center justify-center px-5 py-2.5 min-h-[44px] text-sm font-semibold rounded-lg transition-[filter] hover:brightness-105 disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ background: "var(--gold)", color: "var(--ink)" }}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, ...props }) {
  return (
    <button
      type="button"
      {...props}
      className="inline-flex items-center justify-center px-4 py-2 min-h-[40px] text-sm font-medium rounded-lg transition-[filter] hover:brightness-110 disabled:opacity-40 disabled:cursor-not-allowed"
      style={{ border: "1px solid var(--panel-line)", color: "var(--parchment)", background: "transparent" }}
    >
      {children}
    </button>
  );
}

export const CORRECT = { background: "rgba(52,168,133,0.18)", border: "1px solid var(--teal)", color: "var(--teal)" };
export const WRONG = { background: "rgba(220,90,90,0.15)", border: "1px solid #dc5a5a", color: "#e58c8c" };
export const IDLE = { background: "var(--ink)", border: "1px solid var(--panel-line)", color: "var(--parchment)" };
export const SELECTED = { background: "var(--ink)", border: "1px solid var(--gold)", color: "var(--parchment)", boxShadow: "0 0 0 3px rgba(201,162,39,0.15)" };
